import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  DistrictGusField,
  DistrictGusFieldFromApi,
} from './district-gus-dictionary.model';

@Injectable({
  providedIn: 'root',
})
export class DistrictGusDictionaryService {
  private dictionary: Record<string, Observable<DistrictGusField[]>> = {};
  constructor(private httpClient: HttpClient) {}

  get(voivodeshipId: string | number): Observable<DistrictGusField[]> {
    if (!this.dictionary[voivodeshipId]) {
      this.dictionary[voivodeshipId] = this.httpClient
        .get<
          DistrictGusFieldFromApi[]
        >(`/api/emuia/gus/slo/woj/${voivodeshipId}/powiat`)
        .pipe(
          map((data) =>
            data.map((fieldFromApi) =>
              DistrictGusField.fromApiToApp(fieldFromApi),
            ),
          ),
          shareReplay(1),
        );
    }

    return this.dictionary[voivodeshipId];
  }
}
